module.exports = __webpack_public_path__ + "static/03-610d1f6afc71ea2f9365aa926175ed04.jpg";